import {
  BaseApiInterface,
  getData,
} from 'modules/digital-product/resources/hooks/use-digital-resources'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CLASSIC_COURSE_LIST_ALL_API } from '../../api/courses-api'

export const useClassicCoursesListAll = () => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, BaseApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data, mutate } = useControlledSwr(() => {
    if (!user) return null
    return [`${CLASSIC_COURSE_LIST_ALL_API}?active=true`, RequestModuleEnum.MembershipCourse]
  }, fetcher)

  return {
    coursesData: getData(data),
    mutate,
  }
}
